import { cn } from "@/shared/lib/utils";

import type { AcqContactLine } from "../../api/acqService";

const TYPE_LABEL: Record<AcqContactLine["type"], string> = {
  mobile: "手机",
  landline: "固话",
  email: "邮箱",
};

/**
 * 主号码之外的联系人(1025 启客拓客)。一家企业解锁回来常有好几个人 —— 决策人打不通还有关键人,
 * 销售在拨号之前就该看见,而不是回启客里再翻一遍。没有就整块不渲染。
 */
export function ContactOthers({ others }: { others?: AcqContactLine[] | null }) {
  if (!others || others.length === 0) return null;
  return (
    <ul
      className="mt-1.5 space-y-0.5 border-l-2 border-border pl-2 text-2xs"
      data-testid="acq-contact-others"
    >
      {others.map((c) => (
        <li key={`${c.type}:${c.value}`} className="flex flex-wrap items-center gap-x-1.5">
          {c.type === "email" ? (
            <a
              href={`mailto:${c.value}`}
              className="font-mono text-primary underline-offset-2 hover:underline"
            >
              {c.value}
            </a>
          ) : (
            <span
              className={cn(
                "font-mono",
                c.tags.includes("疑似空号") && "text-muted-foreground line-through"
              )}
            >
              {c.value}
            </span>
          )}
          <span className="text-muted-foreground">
            {[TYPE_LABEL[c.type], c.name, c.duty].filter(Boolean).join(" · ")}
          </span>
          {c.tags.map((t) => (
            <span
              key={t}
              className={cn(
                "rounded px-1 font-semibold",
                t === "疑似空号" ? "bg-muted text-muted-foreground" : "bg-primary/10 text-primary"
              )}
            >
              {t}
            </span>
          ))}
        </li>
      ))}
    </ul>
  );
}
